import React from 'react';
import "./CardPreguntasFrecuentes.scss";
function CardPreguntasFrecuentes({ title, description, video }) {

  const handleLinkClick = (event) => {
    event.preventDefault();
    const url = event.target.href;
    window.open(url, "_blank");
  };

  return (
    <div className=" col-12 md:col-4 cardPreguntasFrecuentes">
      <div className="field borderPreguntasFrecuentes">
        <p className='borderPreguntasFrecuentes__title' >
          <span >
            <b>{title}</b>
          </span>
        </p>
        <p className='borderPreguntasFrecuentes__description'>
          {video == false ? (
            <span className="fontsizesmall">
              {description}
            </span>
          ) : (
            <>
              <span className="fontsizesmall">Mira el siguiente video:  <a className="fontsizesmall"
                style={{
                  color: "blue",
                }}
                href={description}
                onClick={handleLinkClick}
              >
                {description}
              </a> </span>
            </>
          )}

        </p>
      </div>
    </div>
  )
}

export default CardPreguntasFrecuentes